export const FORMAT = { JSON: 'json', CSV: 'csv', xlsx: 'xlsx' };

export const formats = [
  { name: FORMAT.JSON, value: FORMAT.JSON },
  { name: FORMAT.CSV, value: FORMAT.CSV },
  { name: FORMAT.xlsx, value: FORMAT.xlsx },
];

export const TYPE_FORMAT = {
  [FORMAT.JSON]: 'application/json',
  [FORMAT.CSV]: 'text/csv',
  [FORMAT.xlsx]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
